import React from 'react';
import { Section } from '../ui/Section';
import { motion } from 'framer-motion';
export function ResultsSection() {
  const results = ['Duermes un poco mejor porque tu mente deja de correr en círculos', 'Llegas al trabajo con un guion interno más firme', 'Reduces la cantidad de “daño” que te haces por aguantar', 'Empiezas a moverte en silencio (sin anunciar nada)'];
  return <Section variant="darker" className="border-y border-neutral-900" data-id="element-103">
      <div className="max-w-2xl mx-auto" data-id="element-104">
        <h2 className="text-3xl font-bold text-white uppercase tracking-tight mb-6" data-id="element-105">
          Cómo se siente el cambio
        </h2>

        <p className="text-neutral-500 mb-8" data-id="element-106">
          No te voy a decir “en 30 días amarás tu vida”. Eso es mentira.
          <br data-id="element-107" />
          <span className="text-neutral-300" data-id="element-108">Lo realista:</span>
        </p>

        <ul className="space-y-6" data-id="element-109">
          {results.map((result, i) => <motion.li key={i} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex items-start text-lg text-neutral-200" data-id="element-110">
              <span className="text-red-600 mr-4 font-bold" data-id="element-111">—</span>
              {result}
            </motion.li>)}
        </ul>

        <div className="mt-10 p-6 bg-neutral-800/30 rounded-lg border border-neutral-800 text-center" data-id="element-112">
          <p className="text-neutral-400 mb-2" data-id="element-113">
            Y aparece una sensación olvidada:
          </p>
          <p className="text-2xl font-bold text-white" data-id="element-114">“Tengo opciones”</p>
        </div>
      </div>
    </Section>;
}